import React from "react";

const Lightbox = ({ image, closeModal, images, navigateImage }) => {
  const { id, url, text } = image;

  return (
    <div className="fixed inset-0 bg-black bg-opacity- flex justify-center items-center z-50">
      <button
        onClick={closeModal}
        className="absolute top-2 text-2xl right-8 text-white bg-black rounded-full p-2"
      >
        ×
      </button>
      <div className="relative bg-bl p-4 rounded-lg max-w-[80vw] max-h-[80vh] overflow-">
        {/* Previous Button */}
        <button
          onClick={() => navigateImage("prev")}
          className="absolute -left-8 top-1/2 transform -translate-y-1/2 text-white text-3xl"
        >
          &#10094;
        </button>

        <div className="relative">
          {/* Image */}
          <img
            src={url}
            alt={text}
            className="max-w-full max-h-[70vh] object-contain"
          />
          <p className="w-full absolute left-1/2 -translate-x-1/2 bottom-0 py-3 px-4 text-xs font-bold bg-black bg-opacity-50 text-left text-white">
            {image.text}
          
          </p>
        </div>
        {/* Next Button */}
        <button
          onClick={() => navigateImage("next")}
          className="absolute -right-8 top-1/2 transform -translate-y-1/2 text-white text-3xl"
        >
          &#10095;
        </button>
      </div>
    </div>
  );
};

export default Lightbox;
